import { registerLoginParser } from '../me/login';
import { $api } from '../y/api';
import { makeDataStore } from '../y/data-store';
import { YI18NString } from '../y/i18n';
import { $id, YFlags, YId, YMaybeObjectId, YTaggedId, YTimeString } from '../y/types';
import { c_cities, UCoordinates } from './c-city';
import { CHEventVenue } from './c-event-home';

export type CVenueId = YTaggedId<'c_venue'>;
export type CVenueSceneId = YTaggedId<'c_venue_scene'>;

export interface CVenueScene {
    id: CVenueSceneId;
    venue_id: CVenueId;
    is_active: boolean;
    show_scene: boolean;
    name: string;
    capacity?: number;
    min_amount?: number;
}

type CVenueFlag = 'no_index' | 'no_map';

export interface CVenue {
    id: CVenueId;
    is_active: boolean;
    is_published: boolean;
    is_test: boolean;
    added_by_id: YId;
    city_id: YId;
    name: string;
    slug: string;
    description: YI18NString;
    texts: Record<string, YI18NString>;
    address: string;
    location: UCoordinates;
    map_zoom: number;
    place_id?: string;
    flags: YFlags<CVenueFlag>;
    picture_ids: YId[];
    created_at: YTimeString;
    updated_at: YTimeString;
}

export interface CVenueSceneView extends CVenue {
    scenes: CVenueScene[];
}

export const c_venues = makeDataStore('venues', 'venue', (m: CVenueSceneView) => m, Object.assign);

export function cVenueScreenLocation(venue: CVenue) {
    return ['venue', c_cities.maybe(venue.city_id)!.slug, venue.slug];
}

export function cVenuePageURL(venue: CVenue) {
    return 'https://abundolive.se/' + cVenueScreenLocation(venue).join('/');
}

function mapsURLToStaticMap(location: UCoordinates, zoom: number) {
    return `https://maps.googleapis.com/maps/api/staticmap?center=${location.lat},${location.lng}&zoom=${zoom}&size=570x375&scale=2&format=png&map_id=c9d1cc6551c57306&key=AIzaSyB2Fyct3cPmh4KwnJcNW1vK0gFNegMYGzc`;
}

export function cVenueStaticMap(venue: CVenue | CHEventVenue) {
    if(!venue.location) return;
    return mapsURLToStaticMap(venue.location, venue.map_zoom);
}

export function cVenueGoogleMaps(venue: CVenue | CHEventVenue) {
    return `https://www.google.com/maps/@${venue.location.lat},${venue.location.lng},${venue.map_zoom}z`;
}

export function cVenueDisplayName(venue: CVenueSceneView, scene: false | YMaybeObjectId) {
    if(scene && $id.isValidObjectId(scene)) {
        for(const s of venue.scenes || []) {
            if(s.id == $id.objectIdToId(scene))
                return venue.name + ', ' + s.name;
        }
    }

    return venue.name;
}

//TODOURGENT: use newer endpoint
export function cVenuesByCity(city_id: YId) {
    return $api.GET<CVenueSceneView[]>('city/' + city_id + '/venues').then(models => {
        models.forEach(c_venues.register);
        return models;
    });
}
export function cVenueCanDelete(_venue: CVenueSceneView) {
    return false;
    //TODOURGENT
    // const id = $id.idToObjectId(venue.id);
    // return !events.all.find(e => e.model.venue == id);
}

registerLoginParser(data => {
    if(data.venues)
        c_venues.init(data.venues);
});

declare global {
    interface Window {
        ab_venue?: CVenueSceneView;
    }
}

if(window.ab_venue)
    c_venues.register(window.ab_venue);
